// ── Pre-launch lockdown ──
// Until LAUNCH_DATE the public site is restricted to the front page, new
// member signups and purchases are disabled (also enforced server-side),
// and a launch notice is shown on the front page. Everything unlocks
// automatically on launch day — no redeploy needed.
// Keep in sync with LAUNCH_DATE in backend/core/config.py.

export const LAUNCH_DATE_ISO = '2026-10-15';

// Public messaging names the quarter rather than an exact day, so the launch
// window can shift within the quarter without a copy change. Derived from
// LAUNCH_DATE_ISO to stay in step with the gate above.
const ORDINALS = ['1st', '2nd', '3rd', '4th'];
export const LAUNCH_DATE_DISPLAY = (() => {
  const [year, month] = LAUNCH_DATE_ISO.split('-').map(Number);
  return `${ORDINALS[Math.floor((month - 1) / 3)]} Quarter ${year}`;
})();

export const isPrelaunch = () =>
  new Date() < new Date(`${LAUNCH_DATE_ISO}T00:00:00Z`);
